import React, { useMemo } from 'react';
import cn from 'classnames';
import styles from "./Loader.module.scss";

/** Used to signify a loading state. */
export function Loader() {
  const background = 'transparent';
  const duration = 1.7;
  const width = 80;
  const rootStyle = useMemo(() => ({
    background: background,
    width: "".concat(width, "px")
  }), [background, width]);
  const durationCss = useMemo(() => ({
    animationDuration: "".concat(duration, "s")
  }), [duration]);
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 40.3",
    style: rootStyle
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "anchor-logo-linear-gradient-1",
    x1: "-.486",
    x2: "1.553",
    y1: ".693",
    y2: ".206"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".18",
    stopColor: "#4a0d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".277",
    stopColor: "#7c2091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".374",
    stopColor: "#a731ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".461",
    stopColor: "#c53dbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".535",
    stopColor: "#d845c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".586",
    stopColor: "#df48cd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "anchor-logo-linear-gradient-2",
    x1: "1.174",
    x2: "-.716",
    y1: ".029",
    y2: "1.562"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".045",
    stopColor: "#001480",
    stopOpacity: ".898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".079",
    stopColor: "#063194",
    stopOpacity: ".918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".162",
    stopColor: "#1673c1",
    stopOpacity: ".953"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".233",
    stopColor: "#21a3e2",
    stopOpacity: ".976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".286",
    stopColor: "#28c1f7",
    stopOpacity: ".992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".316",
    stopColor: "#2bcdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".429",
    stopColor: "#3edbdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".562",
    stopColor: "#52eab7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".634",
    stopColor: "#5af0aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "anchor-logo-linear-gradient-3",
    x1: "-.679",
    x2: "1.269",
    y1: "1.604",
    y2: "-.273"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: ".423",
    stopColor: "#643cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".609",
    stopColor: "#7268ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".774",
    stopColor: "#7d89ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".865",
    stopColor: "#8296ff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("path", {
    className: cn(styles.draw, styles.draw1),
    style: durationCss,
    d: "M6 28 Q15 15 36 0.5",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("path", {
    className: cn(styles.draw, styles.draw2),
    style: durationCss,
    d: "M29 0.5 Q45 0 34 20Q25 35 38 40",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("path", {
    className: cn(styles.draw, styles.draw3),
    style: durationCss,
    d: "M33 39 l15 -10",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "part3",
    mask: "url(#mask3)",
    d: "M36.037 39.357c5.2.912 11.674-10 11.674-10l-12.371.81c-1.592 4.643-1.96 8.105.697 9.19z",
    fill: "url(#anchor-logo-linear-gradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "part1",
    mask: "url(#mask1)",
    d: "M36.211 3.839c-1.154-1.7-.743-1.873-2.88-2.2-.679-.1-1.111-2.546-7.435.742-8.449 4.393-21.934 19.426-25.4 24.043l16.484-1.079c3.74-4.41 11.225-12.673 15.613-14.879 2.912-2.022 5.131-4.391 3.618-6.627z",
    fill: "url(#anchor-logo-linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "part2",
    mask: "url(#mask2)",
    d: "M40.265 19.289c.248-.556.472-.977.587-1.252 2.279-5.495 4.894-9.258 1.453-13.372-2.346-2.8-8.674-5.585-14.062-3.352 2.28-.482 4-.325 5.115 1.319 1.95 2.89-2.112 9.011-3.612 12.206a88.24 88.24 0 0 0-4.471 10.292c-.832 2.585-1.521 5.892.314 8.226 1.589 2.02 6.11 4.445 7.367 4.987a10.845 10.845 0 0 0 3.408 1.054c-4.82-1.935.608-12.76 3.901-20.108z",
    fill: "url(#anchor-logo-linear-gradient-3)"
  })));
}